import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

//Components
import { DynamicFieldDirective } from '../../src/app/modules/_shared/components/dynamic-field/dynamic-field.directive';
import { DescontoLoversComponent } from './modules/_pages/_desconto-lovers/desconto-lovers.component';
import { AccordionComponent } from './modules/_shared/components/accordion/accordion.component';
import { ButtonComponent } from './modules/_shared/components/button/button.component';
import { ButtonImageComponent } from './modules/_shared/components/button/buttonImage.component';
import { ButtonSubmitComponent } from './modules/_shared/components/button/buttonSubmit.component';
import { CadastroChatComponent } from './modules/_shared/components/cadastro-chat/cadastro-chat.component';
import { CardCarouselComponent } from './modules/_shared/components/card-carousel/card-carousel.component';
import { CardConteudoComponent } from './modules/_shared/components/card-conteudo/card-conteudo.component';
import { CardDesafioComponent } from './modules/_shared/components/card-desafio/card-desafio.component';
import { CardExperienciaComponent } from './modules/_shared/components/card-experiencia/card-experiencia.component';
import { CarouselDinamicoComponent } from './modules/_shared/components/carousel-dinamico/carousel-dinamico.component';
import { CarouselComponent } from './modules/_shared/components/carousel/carousel.component';
import { CheckboxComponent } from './modules/_shared/components/checkbox/checkbox.component';
import { CheckboxCustomComponent } from './modules/_shared/components/checkbox/checkboxCustom.component';
import { CircleProgressComponent } from './modules/_shared/components/circle-progress/circle-progress.component';
import { CircularProgressBarComponent } from './modules/_shared/components/circular-progress-bar/circular-progress-bar.component';
import { ContadorComponent } from './modules/_shared/components/contador/contador.component';
import { DesafiosCarouselComponent } from './modules/_shared/components/desafios-carousel/desafios-carousel.component';
import { DesktopSidebarComponent } from './modules/_shared/components/desktop-sidebar/desktop-sidebar.component';
import { DetalhesExperienciaComponent } from './modules/_shared/components/detalhes-experiencia/detalhes-experiencia.component';
import { DynamicFormComponent } from './modules/_shared/components/dynamic-form/dynamic-form.component';
import { ExperienciasComponent } from './modules/_shared/components/experiencias/experiencias.component';
import { HamburguerComponent } from './modules/_shared/components/hamburguer/hamburguer.component';
import { ImageComponent } from './modules/_shared/components/image/image.component';
import { InputComponent } from './modules/_shared/components/input/input.component';
import { TextAreaComponent } from './modules/_shared/components/input/text-area.component';
import { LabelComponent } from './modules/_shared/components/label/label.component';
import { LabelImageComponent } from './modules/_shared/components/label/labelImage.component';
import { LocalizacaoComponent } from './modules/_shared/components/localizacao/localizacao.component';
import { NoDataComponent } from './modules/_shared/components/no-data/no-data.component';
import { NotificacoesComponent } from './modules/_shared/components/notificacoes/notificacoes.component';
import { OnlyLoaderComponent } from './modules/_shared/components/only-loader/only-loader.component';
import { PontosComponent } from './modules/_shared/components/pontos/pontos.component';
import { PopupComponent } from './modules/_shared/components/popup/popup.component';
import { PopupLoginComponent } from './modules/_shared/components/popupLogin/popup-login.component';
import { GuideComponent } from './modules/_shared/components/popups/guide/guide.component';
import { NpsComponent } from './modules/_shared/components/popups/nps/nps.component';
import { TokenComponent } from './modules/_shared/components/popups/token/token.component';
import { QuizzComponent } from './modules/_shared/components/quizz/quizz.component';
import { RadiobuttonComponent } from './modules/_shared/components/radiobutton/radiobutton.component';
import { RadiobuttonCustomComponent } from './modules/_shared/components/radiobutton/radiobuttonCustom.component';
import { SelectComponent } from './modules/_shared/components/select/select.component';
import { SliderToggleComponent } from './modules/_shared/components/slider/slider-toggle.component';
import { SliderComponent } from './modules/_shared/components/slider/slider.component';
import { TabsNavigationComponent } from './modules/_shared/components/tabs-navigation/tabs-navigation.component';
import { TextoTagComponent } from './modules/_shared/components/texto-tag/texto-tag.component';
import { TimerComponent } from './modules/_shared/components/timer/timer.component';
import { UploadFilesGenericComponent } from './modules/_shared/components/upload/upload-files-generic.component';
import { UploadFilesComponent } from './modules/_shared/components/upload/upload-files.component';

//Header
import { HeaderComponent } from './modules/_shared/components/header/header.component';

//Rodapé
import { FooterComponent } from './modules/_shared/components/footer/footer.component';

//Pontos A Expirar
import { PontosExpirarComponent } from './modules/_shared/components/pontos-expirar/pontos-expirar.component';

//Error
import { ErrorInterceptor } from '../app/modules/_interceptors/error.interceptor';

//Loader
import { LoaderInterceptor } from '../app/modules/_interceptors/loader.interceptor';
import { LoaderComponent } from '../app/modules/_shared/components/loader/loader.component';

//Pages
import { AtendimentoSacComponent } from './modules/_pages/_atendimento-sac/atendimento-sac.component';
import { BeneficiosComponent } from './modules/_pages/_beneficios/beneficios.component';
import { DesafiosDetalhesComponent } from './modules/_pages/_desafios-detalhes/desafios-detalhes.component';
import { DesafiosComponent } from './modules/_pages/_desafios/desafios.component';
import { EsqueciSenhaComponent } from './modules/_pages/_esqueci-senha/esqueci-senha.component';
import { ExperienciaDetalheComponent } from './modules/_pages/_experiencia-detalhe/experiencia-detalhe.component';
import { ExtratoComponent } from './modules/_pages/_extrato/extrato.component';
import { HomeComponent } from './modules/_pages/_home/home.component';
import { IndexComponent } from './modules/_pages/_index/index.component';
import { IndicacoesComponent } from './modules/_pages/_indicacoes/indicacoes.component';
import { LoginRedirectComponent } from './modules/_pages/_login-redirect/login-redirect.component';
import { MeusDadosComponent } from './modules/_pages/_meusdados/meusdados.component';
import { MeusPedidosComponent } from './modules/_pages/_meuspedidos/meuspedidos.component';
import { MinhasExperienciasComponent } from './modules/_pages/_minhas-experiencias/minhas-experiencias.component';
import { NotificacoesPageComponent } from './modules/_pages/_notificacoes/notificacoespage.component';
import { PerfilComponent } from './modules/_pages/_perfil/perfil.component';
import { RedefinicaoSenhaComponent } from './modules/_pages/_redefinicao-senha/redefinicao-senha.component';
import { RemocaoComunicacaoComponent } from './modules/_pages/_remocao-comunicacao/remocao-comunicacao.component';
import { SaibaMaisComponent } from './modules/_pages/_saibamais/saibamais.component';
import { SolicitacoesPageComponent } from './modules/_pages/_solicitacoes/solicitacoespage.component';
import { ValidaDadosComponent } from './modules/_pages/_valida_dados/validadados.component';
import { ValidarDadosComponent } from './modules/_pages/_validar-dados/validar-dados.component';
import { BeneficiosNiveisComponent } from './modules/_shared/components/beneficios-niveis/beneficios-niveis.component';
import { CadastroEnderecoComponent } from './modules/_shared/components/cadastro-endereco/cadastro-endereco.component';
import { FaqComponent } from './modules/_shared/components/faq/faq.component';
import { SacComponent } from './modules/_shared/components/popups/sac/sac.component';
import { SolicitacoesComponent } from './modules/_shared/components/solicitacoes/solicitacoes.component';

//Service
import { AuthService } from './modules/_services/auth.service';
import { FidelidadeService } from './modules/_services/fidelidade.service';
import { LocationService } from './modules/_services/location.service';
import { NotificationsService } from './modules/_services/notifications.service';
import { ValidacaoService } from './modules/_services/validacao.service';

//Pipes
import { DatePipe } from '@angular/common';
import { LinkifyPipe } from './modules/_pipes/linkify.pipe';
import { SingularPluralPipe } from './modules/_pipes/singular-plural.pipe';
import { NumberPipe } from './modules/_shared/pipes/number.pipe';
import { SafePipe } from './modules/_shared/pipes/safe.pipe';

// Directives
import { CountUpDirective } from './modules/_shared/directives/count-up.directive';

//Importe de linguagem
import { registerLocaleData } from '@angular/common';
import localePT from '@angular/common/locales/pt';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgOtpInputModule } from 'ng-otp-input';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxOtpInputModule } from 'ngx-otp-input';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgxSliderModule } from 'ngx-slider-v2';
import { NgxTagsModule } from 'ngx-tags-input-box';
import { AjudaComponent } from './modules/_pages/_ajuda/ajuda.component';
import { CadastroParceirosComponent } from './modules/_pages/_cadastro-parceiros/cadastro-parceiros.component';
import { LandingPageComponent } from './modules/_pages/_landing-page/landing-page.component';
import { LogoutComponent } from './modules/_pages/_logout/logout.component';
import { LoversPelaCausaComponent } from './modules/_pages/_lovers-pela-causa/lovers-pela-causa.component';
import { LpPromocionalComponent } from './modules/_pages/_lp-promocional/lp-promocional.component';
import { MomentosEspeciaisComponent } from './modules/_pages/_momentos-especiais/momentos-especiais.component';
import { PalitoPremiadoComponent } from './modules/_pages/_palito-premiado/palito-premiado.component';
import { BadgePalitoPremiadoComponent } from './modules/_shared/components/badge-palito-premiado/badge-palito-premiado.component';
import { CacausCardComponent } from './modules/_shared/components/cacaus-card/cacaus-card.component';
import { CadastroComponent } from './modules/_shared/components/cadastro/cadastro.component';
import { CardExperienciaProdutosComponent } from './modules/_shared/components/card-experiencia-produtos/card-experiencia-produtos.component';
import { CardExperienciaPromocoesComponent } from './modules/_shared/components/card-experiencia-promocoes/card-experiencia-promocoes.component';
import { CardExperienciaResgatadaComponent } from './modules/_shared/components/card-experiencia-resgatada/card-experiencia-resgatada.component';
import { CardPelaCausaComponent } from './modules/_shared/components/card-pela-causa/card-pela-causa.component';
import { DynamicDisableMessageComponent } from './modules/_shared/components/dynamic-disable-message/dynamic-disable-message.component';
import { EntrarComponent } from './modules/_shared/components/entrar/entrar.component';
import { EsqueciMinhaSenhaComponent } from './modules/_shared/components/esqueci-minha-senha/esqueci-minha-senha.component';
import { ExperienciasProdutoCsComponent } from './modules/_shared/components/experiencias-produto-cs/experiencias-produto-cs.component';
import { FaqNovoComponent } from './modules/_shared/components/faq-novo/faq-novo.component';
import { NiveisProgressBarComponent } from './modules/_shared/components/niveis-progress-bar/niveis-progress-bar.component';
import { PreviewImageComponent } from './modules/_shared/components/preview-image/preview-image.component';
import { MaterialModule } from './modules/_shared/components/utils/material.module';
import { BoldColorPipe } from './modules/_shared/pipes/bold-color.pipe';
import { ExtratoFilterPipe } from './modules/_shared/pipes/extrato-filter.pipe';
import { MoedaPipe } from './modules/_shared/pipes/moeda.pipe';
import { VoucherComponent } from './modules/_shared/components/modal/voucher/voucher.component';
import { InputLoversComponent } from './modules/_shared/components/input-lovers/input-lovers.component';
import { ButtonLoversComponent } from './modules/_shared/components/button-lovers/button-lovers.component';
import { DropdownLoversComponent } from './modules/_shared/components/dropdown-lovers/dropdown-lovers.component';
import { CheckboxLoversComponent } from './modules/_shared/components/checkbox-lovers/checkbox-lovers.component';
import { ValidetePasswordComponent } from './modules/_shared/components/validete-password/validete-password.component';
import { RedirectComponent } from './modules/_pages/_redirect/redirect.component';

registerLocaleData(localePT);

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    LoaderComponent,
    DynamicFieldDirective,
    DynamicFormComponent,
    ButtonComponent,
    ButtonImageComponent,
    LabelComponent,
    LabelImageComponent,
    InputComponent,
    HomeComponent,
    HeaderComponent,
    PontosExpirarComponent,
    SaibaMaisComponent,
    ImageComponent,
    ExtratoComponent,
    EsqueciSenhaComponent,
    SliderComponent,
    RadiobuttonComponent,
    RadiobuttonCustomComponent,
    CheckboxComponent,
    CheckboxCustomComponent,
    IndexComponent,
    CarouselComponent,
    LinkifyPipe,
    SingularPluralPipe,
    MeusPedidosComponent,
    TabsNavigationComponent,
    PerfilComponent,
    BeneficiosNiveisComponent,
    CircleProgressComponent,
    UploadFilesComponent,
    MeusDadosComponent,
    ButtonSubmitComponent,
    SelectComponent,
    CardConteudoComponent,
    CardCarouselComponent,
    FaqComponent,
    SacComponent,
    DesktopSidebarComponent,
    LoginRedirectComponent,
    RedefinicaoSenhaComponent,
    DescontoLoversComponent,
    GuideComponent,
    NoDataComponent,
    OnlyLoaderComponent,
    AtendimentoSacComponent,
    TextAreaComponent,
    QuizzComponent,
    NpsComponent,
    TokenComponent,
    NotificacoesComponent,
    NotificacoesPageComponent,
    DesafiosComponent,
    DesafiosDetalhesComponent,
    DesafiosCarouselComponent,
    UploadFilesGenericComponent,
    SliderToggleComponent,
    CadastroChatComponent,
    CountUpDirective,
    NumberPipe,
    HamburguerComponent,
    CarouselDinamicoComponent,
    PopupComponent,
    PopupLoginComponent,
    PontosComponent,
    CircularProgressBarComponent,
    ExperienciaDetalheComponent,
    DetalhesExperienciaComponent,
    CardDesafioComponent,
    BoldColorPipe,
    CardExperienciaComponent,
    ExperienciasComponent,
    AccordionComponent,
    ContadorComponent,
    MoedaPipe,
    SafePipe,
    LocalizacaoComponent,
    MinhasExperienciasComponent,
    CardExperienciaResgatadaComponent,
    CardExperienciaPromocoesComponent,
    AjudaComponent,
    TextoTagComponent,
    SolicitacoesComponent,
    SolicitacoesPageComponent,
    IndicacoesComponent,
    LandingPageComponent,
    EntrarComponent,
    CadastroComponent,
    CadastroEnderecoComponent,
    RemocaoComunicacaoComponent,
    CadastroParceirosComponent,
    BeneficiosComponent,
    LpPromocionalComponent,
    MomentosEspeciaisComponent,
    DynamicDisableMessageComponent,
    CacausCardComponent,
    NiveisProgressBarComponent,
    EsqueciMinhaSenhaComponent,
    ValidaDadosComponent,
    TimerComponent,
    LogoutComponent,
    ExtratoFilterPipe,
    ExperienciasProdutoCsComponent,
    CardExperienciaProdutosComponent,
    LoversPelaCausaComponent,
    CardPelaCausaComponent,
    ValidarDadosComponent,
    PalitoPremiadoComponent,
    FaqNovoComponent,
    BadgePalitoPremiadoComponent,
    PreviewImageComponent,
    VoucherComponent,
    InputLoversComponent,
    ButtonLoversComponent,
    DropdownLoversComponent,
    CheckboxLoversComponent,
    ValidetePasswordComponent,
    RedirectComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    MaterialModule,
    BrowserAnimationsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgCircleProgressModule.forRoot(),
    ImageCropperModule,
    NgxSkeletonLoaderModule,
    NgxSliderModule,
    NgxOtpInputModule,
    NgOtpInputModule,
    NgxTagsModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AuthService,
    FidelidadeService,
    NotificationsService,
    DatePipe,
    ValidacaoService,
    SingularPluralPipe,
    LocationService,
    provideNgxMask(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
